import React from "react";

export default ({
  merchant,
  invoice,
  item_number,
  item_name,
  item_desc = "",
  amount,
  currency,
  allow_currencies,
  ipn_url,
  success_url,
  cancel_url,
  first_name,
  last_name,
  email
}) => {
  return (
    <div>
      <form action="https://www.coinpayments.net/index.php" method="post">
        <input type="hidden" name="cmd" value="_pay_simple" />
        <input type="hidden" name="reset" value="1" />
        <input type="hidden" name="merchant" value={merchant} />
        {allow_currencies && <input type="hidden" name="allow_currencies" value={allow_currencies} />}
        <input type="hidden" name="currency" value={currency} />
        <input type="hidden" name="amountf" value={amount} />
        {invoice && <input type="hidden" name="invoice" value={invoice} />}
        <input type="hidden" name="item_number" value={item_number} />
        <input type="hidden" name="item_name" value={item_name} />
        {item_desc && (
          <input type="hidden" name="item_desc" value={item_desc} />
        )}
        <input type="hidden" name="want_shipping" value="0" />
        {ipn_url && <input type="hidden" name="ipn_url" value={ipn_url} />}
        {success_url && (
          <input type="hidden" name="success_url" value={success_url} />
        )}
        {cancel_url && (
          <input type="hidden" name="cancel_url" value={cancel_url} />
        )}
        {first_name && (
          <input type="hidden" name="first_name" value={first_name} />
        )}
        {last_name && (
          <input type="hidden" name="last_name" value={last_name} />
        )}
        {email && <input type="hidden" name="email" value={email} />}
        <input
          type="hidden"
          name="success_url"
          value="http://www.yoursite.com/success"
        />
        <input
          type="image"
          src="https://www.coinpayments.net/images/pub/buynow-med.png"
          alt="Buy Now with CoinPayments.net"
          style={{border:'0'}}
        />
      </form>
    </div>
  );
};
